import React from 'react';
import { TabsWrapperProps } from './interfaces';
import { TabsWrapperComponent, TabsInnerWrapper } from './styles';

const TabsWrapper: React.FC<TabsWrapperProps> = ({
  children,
  innerMaxWidthPx,
  innerWidthPercent,
  background,
}) => {
  return (
    <TabsWrapperComponent background={background}>
      <TabsInnerWrapper
        innerMaxWidthPx={innerMaxWidthPx}
        innerWidthPercent={innerWidthPercent}
      >
        {children}
      </TabsInnerWrapper>
    </TabsWrapperComponent>
  );
};

export default TabsWrapper;
